<template>
  <VListItemTitle :class="{ 'ui-list-item__title_text-wrapped': textWrap }">
    <slot />
  </VListItemTitle>
</template>

<script setup lang="ts">
import { VListItemTitle } from 'vuetify/components/VList';

interface Props {
  textWrap?: boolean;
}

defineProps<Props>();
</script>

<style scoped>
.ui-list-item__title_text-wrapped {
  word-wrap: normal !important;
  overflow: visible !important;
  white-space: normal !important;
}
</style>
